module.exports = __webpack_public_path__ + "img/logo2.0cf1c663.png";